import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, UntypedFormGroup } from '@angular/forms';
import { TimeField } from '@app/shared/models/time-field';

@Component({
  selector: 'app-time-input',
  templateUrl: './time-input.component.html',
  styleUrls: ['./time-input.component.scss'],
})
export class TimeInputComponent implements OnInit {
  @Input()
  parentForm: UntypedFormGroup;

  @Input()
  inputName: string;

  @Input()
  labelName: string;

  @Input()
  set defaultTime(value: TimeField) {
    if (value != null) {
      this.timeValue.hour = value.hour + 2;
      this.timeValue.minute = value.minute;
    }
  }

  @Input()
  editable = true;

  @Input()
  flagAsRequired: boolean;

  @Input()
  hideLabel: boolean;

  @Input()
  prependButton: boolean;

  @Input()
  buttonIcon: string;

  @Input()
  showSuccess = false;

  @Output()
  inputFocused = new EventEmitter<string>();

  @Output()
  inputBlurred = new EventEmitter<string>();

  @Output()
  iconButtonClick = new EventEmitter();

  timeValue = { hour: -1, minute: -1 };

  get value() {
    return this.parentForm.get(this.inputName) as FormControl;
  }

  ngOnInit(): void {
    const timeFormControl = this.parentForm.get(this.inputName);
    if (!timeFormControl) {
      return;
    }

    const initialTimeValue = timeFormControl.value;
    if (initialTimeValue) {
      this.timeValue = {
        hour: initialTimeValue.hour ?? 0,
        minute: initialTimeValue.minute ?? 0,
      };
    }

    timeFormControl.valueChanges.subscribe((updatedTimeValue) => {
      if (!updatedTimeValue) {
        return;
      }

      this.timeValue = {
        hour: updatedTimeValue.hour ?? 0,
        minute: updatedTimeValue.minute ?? 0,
      };
    });
  }

  change() {
    this.parentForm.controls[this.inputName].setValue(this.timeValue);
    this.parentForm.controls[this.inputName].markAsDirty();
  }

  onFocus() {
    this.inputFocused.emit(this.inputName);
  }

  onBlur() {
    this.inputBlurred.emit(this.inputName);
  }
}
